import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Card, Col, Empty, Modal, Row, Space, Typography } from 'antd';
import _ from 'lodash';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import ListHeader from '../../../../components/ListHeader';
import { Feature, ProductVersionModel } from '../../../../models/product-interface';
import { Profile } from '../../../../models/profile-interface';
import { CustomerServiceQueries } from '../../../../queries/customer-service-queries';
import { ProductQueries } from '../../../../queries/product-queries';
import ActiveRatePlanCard from '../../components/ActiveRatePlanCard';
import RatePlanSelectCard from '../../components/RatePlanSelectCard';
import SupportLevelCard from '../../components/SupportLevelCard';
import AddFeaturesModal from '../../../../components/modals/AddFeatureModal';

const { Title } = Typography; 

type Filter = {
  text: string;
  value: number | string;
}

type Props = {
    profile: Profile;
    product: ProductVersionModel;
    visible: boolean;
    isDrafting: boolean;
    draftFeatureList: Feature[];
    setDraftFeatureList: React.Dispatch<React.SetStateAction<Feature[]>>
  }
  
  const ProductSupport: React.FC<Props> = ({ 
    profile,
    product,
    visible,
    isDrafting,
    draftFeatureList,
    setDraftFeatureList
  }) => {
    const productSupportTiersQuery = CustomerServiceQueries.useSupportTiersForProduct(product?.product?.id);
    const productRatePlanQuery = ProductQueries.useRatePlanForProduct(product?.product?.id);
    const allSupportTiersQuery = CustomerServiceQueries.useSupportTiers();

  return <React.Fragment key={"support"}>
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Space direction="vertical">
          <Title level={3}>Product Tier</Title>
          <div>This is the default support level for this product.</div>
          <SupportLevelCard
            productId={product?.product?.id}
            ratePlanId={null}
            supportTier={productSupportTiersQuery.data?.length > 0 ? productSupportTiersQuery.data.find(x => x.ratePlanId == null)?.supportTier : null}
            allSupportTiers={allSupportTiersQuery.data ?? []}
          />
        </Space>
      </Col>
      <Col span={12}>
        <Space direction="vertical">
          <Title level={3}>Rate Plan Tiers</Title>
          <span>You can specify different support tiers based on the rate plan the customer has for this product. If you do <b>not</b> define a support tier for a specific rate plan, it will use the support tier chosen at the product level.</span>
          <RatePlanSelectCard
            productId={product?.product?.id}
            allRatePlans={productRatePlanQuery.data ?? []}
            selectedRatePlans={productSupportTiersQuery?.data ?? []}
            allSupportTiers={allSupportTiersQuery.data ?? []}
          />
          {productSupportTiersQuery?.data?.filter(x => x.ratePlanId != null).map((plan, index) => (
            <React.Fragment key={`plan-${index}`}>
              <ActiveRatePlanCard
                ratePlanName={productRatePlanQuery.data?.find(x => x.id == plan.ratePlanId)?.name ?? ""}
                productSupport={plan}
              />
            </React.Fragment>
          ))}
        </Space>
      </Col>
    </Row>
  </React.Fragment>
}


export default ProductSupport;